var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"value":_vm.value,"placeholder":`${_vm.$tc('status')} DIAN`},on:{"input":_vm.onSelect}},[_c('option',{key:"Valid",attrs:{"value":"00"}},[_vm._v(" "+_vm._s(_vm.$tc('valid'))+" ")]),_c('option',{key:"Invalid",attrs:{"value":"99"}},[_vm._v(" "+_vm._s(_vm.$tc('invalid'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }